import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

export class LicitacaoDetalheCertidao extends Component {
  static propTypes = {
    certidoes: PropTypes.object.isRequired,
    onDownload: PropTypes.func.isRequired
  };

  renderCertidoes = data => {
    const { onDownload } = this.props;
    const key =
      data.get('fornecedor') +
      '_' +
      data.get('tipoCertidao') +
      '_' +
      data.get('numeroDocumento') +
      '_' +
      data.get('');

    return (
      <TableActions
        ref="row"
        key={key}
        data={data}
        onDownload={data.get('idArquivo') && onDownload}
      >
        <td>{data.get('fornecedor')}</td>
        <td>{data.get('cnpjCpf')}</td>
        <td>{data.get('tipoCertidao')}</td>
        <td>{data.get('numeroDocumento')}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataEmissao'))}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataValidade'))}</td>
      </TableActions>
    );
  };

  render() {
    const { certidoes } = this.props;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={certidoes.isEmpty()}>
            <tr>
              <th>Fornecedor</th>
              <th>CNPJ/CPF</th>
              <th>Tipo Certidão</th>
              <th>Número do Documento</th>
              <th>Emissão</th>
              <th>Validade</th>
              <th></th>
            </tr>
          </TableHeader>
          <tbody>{certidoes.map(this.renderCertidoes)}</tbody>
        </table>
      </div>
    );
  }
}

export default LicitacaoDetalheCertidao;
